import { PropsWithChildren, ReactNode } from 'react';
import { MediaMatch, NewTypography as Typography } from '@lamimed/pantheon';

import { Breadcrumb, Crumb } from 'components/Breadcrumb';
import { LanguageSelect } from 'components/LanguageSelect';

import * as S from './styles';

interface HeaderProps extends PropsWithChildren {
  button?: ReactNode;
  title: string;
  crumbs: Array<Crumb>;
}

export function Header({ title, button, crumbs, children }: HeaderProps) {
  return (
    <S.Container haveTabbar={!!children}>
      <MediaMatch greaterThan="desktop">
        <S.HeaderContent>
          <Breadcrumb crumbs={crumbs} marginBottom="small" />

          <LanguageSelect />
        </S.HeaderContent>
      </MediaMatch>

      <S.HeaderContent>
        <S.Title>
          <Typography as="h1" variant="heading_5" marginBottom="none">
            {title}
          </Typography>

          {button}
        </S.Title>

        <MediaMatch lessThan="desktop">
          <LanguageSelect />
        </MediaMatch>
      </S.HeaderContent>

      {children}
    </S.Container>
  );
}
